module.exports = __webpack_public_path__ + "img/gww_03.97ad976c.jpg";